<script lang="ts" setup>

</script>

<template>

<a href="mailto:sales@connectedvehicles.com.au?subject=Carbucks Protect enquiry">
    <Button variant="flat"
            color="var(--color-primary-600)"
            size="large"
            class="contact-sales-shadow !h-16 text-white !rounded-[8px] tracking-wider w-full flex items-center">
            <span class="text-sm">GET IN TOUCH &raquo;</span>
    </Button>
</a>

</template>

<style lang="scss">

    .contact-sales-shadow 
    {
        box-shadow: 0 1px 1px rgba(0,0,0,0.05), 
                    0 2px 2px rgba(0,0,0,0.05), 
                    0 4px 4px rgba(0,0,0,0.04), 
                    0 8px 8px rgba(0,0,0,0.03),
                    0 16px 16px rgba(0,0,0,0.01);
    }
</style>